import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import KeyMetrics from "@/components/admin/dashboard/KeyMetrics";
import ActivityCharts from "@/components/admin/dashboard/ActivityCharts";
import RecentActivity from "@/components/admin/dashboard/RecentActivity";
import QuickActions from "@/components/admin/dashboard/QuickActions";
import { RefreshCw } from "lucide-react";

const AdminDashboard = () => {
  const { toast } = useToast();

  const handleRefresh = () => {
    toast({
      title: "Refreshing Dashboard",
      description: "Dashboard data is being updated...",
    });
  };

  const handleQuickAction = (action: string) => {
    toast({
      title: "Action Selected",
      description: `Navigating to ${action}...`,
    });
  };

  return (
    <div className="p-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div className="space-y-1">
          <h1 className="text-2xl md:text-3xl font-bold bg-clip-text text-transparent bg-gradient-primary">
            Admin Dashboard
          </h1>
          <p className="text-muted-foreground">
            Monitor and manage your platform's performance
          </p>
        </div>
        <Button 
          variant="outline"
          onClick={handleRefresh}
          className="flex items-center gap-2 hover:shadow-md transition-all duration-200"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh Data
        </Button>
      </div>
      
      <div className="space-y-6">
        <QuickActions onAction={handleQuickAction} />

        <div className="rounded-xl border bg-card p-6 shadow-sm hover:shadow-md transition-all duration-200">
          <KeyMetrics />
        </div>

        <div className="rounded-xl border bg-card p-6 shadow-sm hover:shadow-md transition-all duration-200">
          <ActivityCharts />
        </div>

        <div className="rounded-xl border bg-card p-6 shadow-sm hover:shadow-md transition-all duration-200">
          <RecentActivity />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;